import { createElementBlock as l, openBlock as o, createElementVNode as e } from "vue";
import c from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(a, t, i, f, p, m) {
  return o(), l("svg", n, t[0] || (t[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#F5F2E8",
        d: "M40.837 18.198c-1.255 0-2.438.258-3.472.77C36.59 13.897 32.158 10 26.84 10c-5.799 0-10.526 4.631-10.673 10.367A7.052 7.052 0 0 0 10 27.387c-.002 3.895 3.175 7.057 7.09 7.057h23.747c4.506 0 8.163-3.64 8.163-8.124s-3.657-8.122-8.163-8.122Z"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "m26.84 8.75-.298.004c-5.93.145-10.815 4.634-11.537 10.41l-.018.157-.235.064a8.304 8.304 0 0 0-6.002 8.002c-.003 4.586 3.735 8.307 8.34 8.307h23.747c5.195 0 9.413-4.198 9.413-9.374s-4.218-9.372-9.413-9.372l-.361.006a9.439 9.439 0 0 0-2.08.302l-.124.034-.072-.24c-1.518-4.845-6.082-8.3-11.36-8.3Zm0 2.5c4.652 0 8.6 3.396 9.29 7.908a1.25 1.25 0 0 0 1.79.93c.85-.421 1.841-.64 2.917-.64 3.817 0 6.913 3.08 6.913 6.872 0 3.793-3.096 6.874-6.913 6.874H17.089c-3.225 0-5.84-2.603-5.839-5.807a5.802 5.802 0 0 1 5.074-5.78 1.25 1.25 0 0 0 1.093-1.208c.13-5.072 4.316-9.149 9.423-9.149Zm1.095 29.3a1.25 1.25 0 0 1 2.289.997l-.055.125-1.323 2.633h3.332c.89 0 1.482.897 1.166 1.703l-.049.109-2.233 4.444a1.25 1.25 0 0 1-2.288-.997l.054-.125 1.323-2.634H26.82a1.25 1.25 0 0 1-1.166-1.701l.049-.11 2.232-4.444Z"
      })
    ], -1)
  ]));
}
const h = /* @__PURE__ */ c(r, [["render", s]]);
export {
  h as default
};
